import {
  BooleanSetting,
  useUserSettingWithDefault,
} from "shared-ts-utils-user-settings";
import { SupportingPaneProps } from "./SupportingPaneProps";

export const useSupportingPaneOpen = (props: {
  $key: string;
  supportingPaneProps?: SupportingPaneProps;
}) => {
  return useUserSettingWithDefault(
    `${props.$key}.supportingPaneOpen`,
    BooleanSetting,
    props.supportingPaneProps?.openByDefault ?? false,
    {
      storeLocally: true,
    }
  );
};
